import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotfoundComponent } from './notfound.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [NotfoundComponent]
})
export class NotfoundModule { }
